<script>
export default {
  name: 'SvgIcon',
  functional: true,
  props: {
    height: {
      default: 0,
      type: [Number, String]
    },
    src: {
      type: Object,
      required: true
    },
    width: {
      default: 0,
      type: [Number, String]
    }
  },
  render (h, { props, data }) {
    if (!props.src || !props.src.viewBox) return

    const [x, y, width, height] = props.src.viewBox.split(' ')

    const dimensions = { h: Number(props.height || height), w: Number(props.width || width) }

    if (props.width && !props.height) {
      dimensions.h = Math.round((height / width) * props.width)
    } else if (props.height && !props.width) {
      dimensions.w = Math.round((width / height) * props.height)
    }

    return h('svg', {
      class: data.class,
      attrs: {
        class: data.staticClass,
        height: dimensions.h,
        viewBox: [x, y, width, height].join(' '),
        width: dimensions.w
      }
    }, [h('use', { attrs: { 'xlink:href': '#' + props.src.id } })])
  }
}
</script>
